export default "__VITE_ASSET__BVOTXfC1__"